export type TReactions = 'good' | 'not-good' | 'ok';

export interface ICustomerReview {
	rank: TReactions;
  review: string;
}

export const rankMapping: Record<TReactions, string> = {
  "not-good": 'לא טוב',
  "ok": 'סביר',
  "good": 'טוב מאוד'
}

export interface IReview {
  appointmentId: string;
  customerName: string;
  customerId: string;
  rank: TReactions;
  review: string;
  providerId: string;
  appointmentDate: string; // ISO string
}

export interface IReviewsResponse {
  reviews: IReview[];
  pagination: {
    total: number;
    skip: number;
    limit: number;
    hasMore: boolean;
  };
}

export interface IReviewsSummary {
  averageRating: number; // 1-5 scale based on reactions mapping
  totalReviews: number;
  reactionsBreakdown: Record<TReactions, { count: number; percentage: number }>;
}

